const float = {
    name: "float",
    path: "/float",
    title: "float",
    description: "Utilities for controlling the wrapping of content around an element.",
    value: {
        "float":{
            "float-right": "right",
          "float-left": "left",
          "float-none": "none",
          "float-start": "inline-start",
          "float-end": "inline-end",
        }
    },
    exampleData: [
        {
            "example": {
                "code": `<article>
  <img class="float-right ..." src="/img/mountains.jpg" />
  <p>Maybe we can live without libraries, people like you and me. ...</p>
</article>`
            }
        },
        {
            "example": {
                "code": `<article>
  <img class="float-left ..." src="/img/mountains.jpg" />
  <p>Maybe we can live without libraries, people like you and me. ...</p>
</article>`
            }
        }
        
    ],
    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">float-right </code>
                  utility to float an element to the right of its container:
            </p>
            <div class="relative overflow-auto rounded-lg" style="margin-right: 0px;"><img class="float-right ml-6 aspect-16/9 w-1/3 rounded-lg object-cover outline -outline-offset-1 outline-color-black/10" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo">
                <p
                class="text-justify text-sm leading-6">Maybe we can live without libraries, people like you and me. Maybe. Sure, we're too old to change the world, but what about that kid, sitting down, opening a book, right now, in a branch at the local library and finding drawings of pee-pees and wee-wees
                    on the Cat in the Hat and the Five Chinese Brothers? Doesn't HE deserve better? Look. If you think this is about overdue fines and missing books, you'd better think again. This is about that kid's right to read a book without getting his mind
                    warped! Or: maybe that turns you on, Seinfeld; maybe that's how y'get your kicks. You and your good-time buddies. maybe that turns you on, Seinfeld; maybe that's how y'get your kicks. You and your good-time buddies.</p>
            </div>

            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">float-left </code>
                  utility to float an element to the left of its container:
            </p>
            <div class="relative overflow-auto rounded-lg" style="margin-right: 0px;"><img class="float-left mr-6 aspect-16/9 w-1/3 rounded-lg object-cover outline -outline-offset-1 outline-color-black/10" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo">
                <p
                class="text-justify text-sm leading-6">Maybe we can live without libraries, people like you and me. Maybe. Sure, we're too old to change the world, but what about that kid, sitting down, opening a book, right now, in a branch at the local library and finding drawings of pee-pees and wee-wees
                    on the Cat in the Hat and the Five Chinese Brothers? Doesn't HE deserve better? Look. If you think this is about overdue fines and missing books, you'd better think again. This is about that kid's right to read a book without getting his mind
                    warped! Or: maybe that turns you on, Seinfeld; maybe that's how y'get your kicks. You and your good-time buddies. maybe that turns you on, Seinfeld; maybe that's how y'get your kicks. You and your good-time buddies.</p>
            </div>

            `
        }
    ]
};

export default float;


<div className="sr-only">
<div class="relative overflow-auto rounded-lg bg-color-white outline outline-color-white/5 dark:bg-color-gray-950/50 dark:inset-ring dark:inset-color-ring-white/5" style="margin-right: 0px;"><img class="float-right float-left ml-6 mr-6 aspect-16/9 w-1/3 rounded-lg object-cover outline -outline-offset-1 outline-color-black/10" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
                <p
                class="text-justify text-sm leading-6">Maybe we can live without libraries, people like you and me. Maybe. Sure, we're too old to change the world, but what about that kid, sitting down, opening a book, right now, in a branch at the local library and finding drawings of pee-pees and wee-wees
                    on the Cat in the Hat and the Five Chinese Brothers? Doesn't HE deserve better? Look. If you think this is about overdue fines and missing books, you'd better think again. This is about that kid's right to read a book without getting his mind
                    warped! Or: maybe that turns you on, Seinfeld; maybe that's how y'get your kicks. You and your good-time buddies.</p>
            </div>
</div>